var app = angular.module('app-stores', [
    'uiGmapgoogle-maps',
    'app-helpers'
]); 

app.controller('Stores2', ['$scope', 'helpers', '$http', '$sce', function ($scope, helpers, $http, $sce) {
    $scope.keyword = '';
    $scope.KeywordLatitude = 0;
    $scope.KeywordLongitude = 0;
    $scope.keywordErrorMessage = false;
    $scope.country = country;
    $scope.latlng = defaultLatitude + ',' + defaultLongitude;
    $scope.dealers = [];
    $scope.markers = [];
    $scope.showStartpage = true;
    $scope.campaigns = [];
    $scope.selectedCampaigns = [];
    $scope.showFilterbox = false;
    $scope.markerscontrol = {};
    $scope.infoWindow = '';
    $scope.showGiantStoresDefaultAtStoreFinder = false;
    $scope.rectangle = null;
    $scope.activeTooltipCode = '';
    $scope.activeTooltipDealerCode = '';
    $scope.activeTooltipCampaignCode = '';

    $scope.setMarkers = function () {
        $scope.markers = [];

        if (window.inTestMode != undefined && window.inTestMode) {
            $scope.markers.push({
                latitude: $scope.KeywordLatitude,
                longitude: $scope.KeywordLongitude,
                id: 0,
                show: false,
            });
        }

        $.each($scope.dealers, function (i, dealer) {
            $scope.markers.push({
                latitude: dealer.Latitude,
                longitude: dealer.Longitude,
                title: dealer.Name,
                id: dealer.Id,
                icon: cdn + '/Images/Shared/Stores/' + dealer.MarkerFileName,
                show: false,
                dealer: dealer,
                events: {
                    click: function (e, f, g) {
                        $scope.map.selectedMarker = g;
                        if ($scope.infoWindow) {
                            $scope.infoWindow.close();
                        }
                        $scope.infoWindow = new google.maps.InfoWindow({
                            content: g.infoWindow()
                        });
                        $scope.infoWindow.open(e.map, e)
                    }
                },
                infoWindow: function () {

                    var isInTestMode = (window.inTestMode != undefined && window.inTestMode ? true : false);

                    return (dealer.Image != null ? '<div class="image" style="margin-bottom:10px;"><img src="' + dealer.Image + '" class="img-responsive" style="width:280px;"/></div>' : '') + '<strong>' + dealer.Name + '</strong><br />' +
                        dealer.AddressLocalized + '<br/>' +
                        (dealer.Phone != null ? dealer.Phone + '<br />' : '') +
                        (dealer.Email != null ? '<a href="mailto:' + dealer.Email + '" class="dealer-email">' + dealer.Email + '</a><br />' : '') +
                        (dealer.WebAddress != null && isInTestMode && countryId == 19 && dealer.IsGiantStore ? "" : dealer.WebAddress ? '<a href="http://' + dealer.WebAddress + '" target="_blank" class="dealer-webaddress">' + dealer.WebAddress + '</a><br>' : '') +
                        (dealer.Facebook != null ? '<a href="' + dealer.Facebook + '" target="_blank" class="dealer-webaddress">' + dealer.Facebook + '</a><br>' : '') +
                        (isInTestMode && countryId == 19 && dealer.IsGiantStore ? '<br/><a href="/' + culture + '/store/' + dealer.StoreShortname + '">View store details <span class="glyphicon glyphicon-circle-arrow-right"></span></a>' : ($scope.giantstorespage == true) ? '<a href="http://' + dealer.WebAddress + '" class="btn btn-info">Bekijk store pagina</a>' : '<div style="margin-top:10px;"><a href="https://www.google.com/maps?saddr=' + $scope.KeywordLatitude + ',' + $scope.KeywordLongitude + '&daddr=' + dealer.Latitude + ',' + dealer.Longitude + '" target="_blank"><span class="glyphicon glyphicon-circle-arrow-right"></span> ' + labelDirections + '</a></div>');
                }
            });
        });
    };

    $scope.map = {
        center: {
            latitude: defaultLatitude,
            longitude: defaultLongitude
        },
        bounds: {
            northeast: {
                latitude: 0,
                longitude: 0
            },
            southwest: {
                latitude: 0,
                longitude: 0
            }
        },
        zoom: defaultZoom,
        control: {},
        events: {
            zoom_changed: function (map, eventName, arguments) {
                $scope.mapChanged(map);
            },
            dragend: function (map, eventName, arguments) {
                $scope.mapChanged(map);
            }
        },
        options: {
            scrollwheel: false
        },
        selectedMarker: {}
    };

    $scope.mapChanged = function (map) {
        if ($scope.keyword != undefined && $scope.keyword.length > 0) {
            var padbnds = $scope.addPaddingToBounds(map, 35, 0, 12, 12); //north, south, east and west
            $scope.map.bounds = {
                northeast: {
                    latitude: padbnds.getNorthEast().lat(),
                    longitude: padbnds.getNorthEast().lng()
                },
                southwest: {
                    latitude: padbnds.getSouthWest().lat(),
                    longitude: padbnds.getSouthWest().lng()
                }
            };
            console.log('NE: ' + $scope.map.bounds.northeast.latitude + ',' + $scope.map.bounds.northeast.longitude);
            console.log('SW: ' + $scope.map.bounds.southwest.latitude + ',' + $scope.map.bounds.southwest.longitude);

            $scope.getDealers();
        }
    };

    $scope.showInfoWindow = function (id) {
        $scope.map.selectedMarker = $scope.markers.filter(function (x) { return x.id == id })[0];
        var marker = $scope.markerscontrol.getGMarkers().filter(function (x) { return x.key == id })[0];
        $scope.map.selectedMarker.events.click(marker, 'click', $scope.map.selectedMarker);
    };

    $scope.keydown = function () {
        if (event.keyCode == 13 && $scope.keyword.length > 0) {
            $scope.getGeolocation();
        }
    }

    $scope.getBrowserlocation = function () {
        $scope.showGiantStoresDefaultAtStoreFinder = false;
        helpers.getBrowserLocation(function (lat, lng, keyword) {
            $scope.map.center.latitude = lat;
            $scope.map.center.longitude = lng;
            $scope.keyword = keyword;
            $scope.KeywordLatitude = lat;
            $scope.KeywordLongitude = lng;
            $scope.showStartpage = false;
            //$scope.map.options.scrollwheel = true;
            $scope.resetBounds();
            $scope.getDealers($scope.fitBounds);
            $scope.keywordErrorMessage = false;
        });
    }

    $scope.getGeolocation = function () {
        if ($scope.keyword.length > 0) {
            $scope.showGiantStoresDefaultAtStoreFinder = false;
        } else {
            $scope.showGiantStoresDefaultAtStoreFinder = true;
        }

        console.log();

        helpers.getGeolocation($scope.keyword, function (lat, lng) {
            if (lat != undefined && lng != undefined) {
                $scope.map.center.latitude = lat;
                $scope.map.center.longitude = lng;
                $scope.KeywordLatitude = lat;
                $scope.KeywordLongitude = lng;
                $scope.showStartpage = false;
                if ($scope.giantstorespage == true) {
                    $scope.map.options.scrollwheel = false;
                } else {
                    $scope.map.options.scrollwheel = true;
                }
                $scope.resetBounds();
                $scope.getDealers($scope.fitBounds);
                $scope.keywordErrorMessage = false;
            } else {
                $scope.keywordErrorMessage = true;
                $scope.$apply();
            }
        });
    };

    $scope.initiateDealerSearch = function () {
        for (var i = 0; i < $scope.campaigns.length; i++) {
            if ($scope.campaigns[i].selected == true) {
                $scope.setCampaign($scope.campaigns[i].code);

                var the_string = 'selectCampaign' + $scope.campaigns[i].code;
                $scope[the_string] = '' + $scope.campaigns[i].code + '';
            }
        }
    }

    $scope.getDealers = function (callback) {
        $http({
            method: 'POST',
            url: '/' + culture + '/stores/dealers',
            data: {
                latitude: $scope.KeywordLatitude,
                longitude: $scope.KeywordLongitude,
                keyword: $scope.keyword,
                NE_lat: $scope.map.bounds.northeast.latitude,
                NE_lng: $scope.map.bounds.northeast.longitude,
                SW_lat: $scope.map.bounds.southwest.latitude,
                SW_lng: $scope.map.bounds.southwest.longitude,
                campaigncodes: $scope.selectedCampaigns,
                onlyGiantStores: $scope.giantstorespage ? true : false
            }
        }).then(function (res) {
            if (res.data.dealers != undefined && res.data.dealers.length > 0) {
                $scope.dealers = res.data.dealers;
                $scope.filteredBy = res.data.filteredBy;
                $scope.setMarkers();
            }
            if (callback) {
                callback();
            }
        });
    }

    $scope.fitBounds = function () {
        $scope.map.control.refresh();
        if ($scope.dealers.length > 0) {
            var bounds = new google.maps.LatLngBounds();
            $.each($scope.dealers, function (i, dealer) {
                bounds.extend(new google.maps.LatLng(dealer.Latitude, dealer.Longitude));
            });
            //append keyword coordinates to have always 'your home' located.
            bounds.extend(new google.maps.LatLng($scope.KeywordLatitude, $scope.KeywordLongitude));
            var map = $scope.map.control.getGMap();
            map.fitBounds(bounds);
        }
    }

    $scope.resetBounds = function () {
        $scope.map.bounds = {
            northeast: {
                latitude: 0,
                longitude: 0
            },
            southwest: {
                latitude: 0,
                longitude: 0
            }
        };
    }

    $scope.toggleFilterbox = function () {
        if ($scope.showFilterbox) {
            $scope.showFilterbox = false;
        } else {
            $scope.showFilterbox = true;
        }
    }

    $scope.setCampaign = function (code) {
        if ($scope.selectedCampaigns.indexOf(code) > -1) {
            $scope.selectedCampaigns.splice($scope.selectedCampaigns.indexOf(code), 1);
        } else {
            $scope.selectedCampaigns.push(code);
        }
    }

    $scope.selectCampaign = function (code) {
        $scope.setCampaign(code);

        if ($scope.selectedCampaigns.length == 0) {
            $scope.resetBounds();
        }
        $scope.getDealers($scope.fitBounds);
        $scope.toggleFilterbox();
    }

    $scope.toggleTooltip = function (code) {
        if (code == $scope.activeTooltipCode) {
            $scope.activeTooltipCode = '';
        } else {
            $scope.activeTooltipCode = code;
        }
    }

    $scope.toggleTooltipDealerCampaign = function (dealerCode, campaignCode) {

        if (dealerCode == $scope.activeTooltipDealerCode && campaignCode == $scope.activeTooltipCampaignCode) {
            $scope.activeTooltipDealerCode = '';
            $scope.activeTooltipCampaignCode = '';
       } else {
            $scope.activeTooltipDealerCode = dealerCode;
            $scope.activeTooltipCampaignCode = campaignCode;
        }
    }

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $scope.dealerCampaigns = function (campaignCodes) {
        var result = [];
        $.each(campaignCodes, function (i, campaignCode) {
            if (result.filter(function (x) { return x == campaignCode }).length == 0 && $scope.campaigns.filter(function (x) { return x.code == campaignCode }).length > 0) {
                result.push($scope.campaigns.filter(function (x) { return x.code == campaignCode })[0]);
            }
        });
        return result;
    }

    $scope.addPaddingToBounds = function (map, npad, spad, epad, wpad) {
        var SW = map.getBounds().getSouthWest();
        var NE = map.getBounds().getNorthEast();
        var topRight = map.getProjection().fromLatLngToPoint(NE);
        var bottomLeft = map.getProjection().fromLatLngToPoint(SW);
        var scale = Math.pow(2, map.getZoom());

        var SWtopoint = map.getProjection().fromLatLngToPoint(SW);
        var SWpoint = new google.maps.Point(((SWtopoint.x - bottomLeft.x) * scale) + wpad, ((SWtopoint.y - topRight.y) * scale) - spad);
        var SWworld = new google.maps.Point(SWpoint.x / scale + bottomLeft.x, SWpoint.y / scale + topRight.y);
        var pt1 = map.getProjection().fromPointToLatLng(SWworld);

        var NEtopoint = map.getProjection().fromLatLngToPoint(NE);
        var NEpoint = new google.maps.Point(((NEtopoint.x - bottomLeft.x) * scale) - epad, ((NEtopoint.y - topRight.y) * scale) + npad);
        var NEworld = new google.maps.Point(NEpoint.x / scale + bottomLeft.x, NEpoint.y / scale + topRight.y);
        var pt2 = map.getProjection().fromPointToLatLng(NEworld);

        return new google.maps.LatLngBounds(pt1, pt2);
    }
}]);

angular.element(document).ready(function () {
    try {
        var appID = document.getElementById('app-stores');
        angular.bootstrap(appID, ['app-stores']);
    } catch (e) {
        //do nothing
    }
});
